import type { ComponentSchema } from '../../../../../schema-types'

/** Khelaghor: a thin grape strip with these messages, one at a time; a coupon code shows after its message as a sunshine pill. */
export const schema: ComponentSchema = {
  type: 'announcement-bar',
  label: 'Announcement bar',
  description: 'A slim rotating bar of short messages, with an optional coupon code after each.',
  supportedPages: ['home', 'shop', 'product', 'category', 'categories', 'cart', 'checkout', 'contact', 'wishlist'],
  variants: [{ id: 'v1', label: 'Rotating bar' }],
  commonFields: [{
    key: 'items',
    label: 'Messages',
    type: 'array',
    itemSchema: [
      { key: 'text', label: 'Message', type: 'string' },
      { key: 'code', label: 'Coupon code (optional)', type: 'string' },
    ],
    default: [{ text: 'Free delivery all over Bangladesh on orders over 1500' }, { text: 'Cash on delivery available' }],
  }],
}
